<div class="component-container">
  <div class="matero-page-header-inner">
    <h1 class="matero-page-title">Instruções </h1>

    <p>Em desenvolvimento.</p>
  </div>
</div>